<template>
  <section class="accordion outer" v-if="item.modulaccordionueberschrift">
    <div class="container">
      <h2 class="section-title">
        <span class="headline" v-html="item.modulaccordionueberschrift"></span>
      </h2>

      <article class="accordion-item" v-for="i in 3" :key="i">
        <h3 class="accordion-item__head" v-html="item.modulaccordionuntertitel" i></h3>
        <div class="accordion-item__content" v-html="item.modulaccordiontext" i></div>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ModulAccordion',
  data() {
    return {
      item: this.context.item,
    };
  },
  props: {
    context: {
      type: Object,
    },
  },
};
</script>
